// eslint-disable-next-line import/prefer-default-export
export const ACTION_BUTTON_LIST_SPACING = 4;
